import { OnboardingPath } from "@/routes/onboarding/constants/path";
import { useOnboardingStatus } from "@/routes/guards/useOnboardingStatus";

export const ONBOARDING_GUARD_STATUS = {
  LOADING: "loading",
  REDIRECT: "redirect",
  ONBOARDING: "onboarding",
  OBSERVABILITY_SETUP: "observability-setup",
} as const;

type OnboardingGuardStatus = (typeof ONBOARDING_GUARD_STATUS)[keyof typeof ONBOARDING_GUARD_STATUS];

export const useOnboardingGuardState = (
  onboardingPath: OnboardingPath | null,
): OnboardingGuardStatus => {
  const { isLoading, isOnboardingComplete, shouldShowProductSetup } = useOnboardingStatus();

  if (isLoading) {
    return ONBOARDING_GUARD_STATUS.LOADING;
  }

  if (isOnboardingComplete) {
    return ONBOARDING_GUARD_STATUS.REDIRECT;
  }

  if (shouldShowProductSetup && onboardingPath === "observability") {
    return ONBOARDING_GUARD_STATUS.OBSERVABILITY_SETUP;
  }

  return ONBOARDING_GUARD_STATUS.ONBOARDING;
};
